"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createBraintreeGoogle = void 0;
const src_1 = require("../..");
function createBraintreeGoogle() {
    return __awaiter(this, void 0, void 0, function* () {
        const googlePayClient = (0, src_1.getBraintreeGooglePayClientChecked)();
        const googlePayInstance = (0, src_1.getBraintreeGooglePayInstanceChecked)();
        const container = document.getElementById('braintree-google-express-payment');
        const allowedPaymentMethods = googlePayInstance.createPaymentDataRequest().allowedPaymentMethods.filter(m => m.type === 'CARD');
        const isReadyToPay = yield googlePayClient.isReadyToPay({
            apiVersion: src_1.braintreeConstants.GOOGLEPAY_VERSION_NUMBER,
            apiVersionMinor: src_1.braintreeConstants.GOOGLEPAY_VERSION_NUMBER_MINOR,
            allowedPaymentMethods: allowedPaymentMethods,
        });
        if (isReadyToPay.result) {
            if (!container) {
                // creating a braintree-google payment div inside express payment container
                const braintreeDiv = document.createElement('div');
                braintreeDiv.id = 'braintree-google-express-payment';
                braintreeDiv.className = 'braintree-google-express-payment express-payment';
                const button = googlePayClient.createButton({
                    onClick: src_1.braintreeOnClickGoogle,
                    buttonType: 'short',
                    buttonSizeMode: 'fill',
                    allowedPaymentMethods
                });
                button.className = 'braintree-google-pay-button';
                button.id = 'braintree-google-pay-button';
                braintreeDiv.appendChild(button);
                const expressContainer = document.getElementById('express-payment-container');
                if (!expressContainer) {
                    (0, src_1.enableDisableSection)(src_1.showPaymentMethodTypes.BRAINTREE_GOOGLE, false);
                    return;
                }
                expressContainer.appendChild(braintreeDiv);
            }
            const paymentDataRequest = (0, src_1.braintreeCreatePaymentRequestGoogle)();
            googlePayClient.prefetchPaymentData(paymentDataRequest);
            (0, src_1.enableDisableSection)(src_1.showPaymentMethodTypes.BRAINTREE_GOOGLE, true);
        }
        else {
            (0, src_1.enableDisableSection)(src_1.showPaymentMethodTypes.BRAINTREE_GOOGLE, false);
            if (container) {
                container.style.display = 'none';
            }
        }
    });
}
exports.createBraintreeGoogle = createBraintreeGoogle;
